export function setBookingData(payload) {
    return { type: 'BOOKING_DATA', payload }
};
export function clearBooking(payload) {
    return { type: 'CLEAR_BOOKING', payload }
};
export function saveUserData(payload) {
    return { type: 'SAVE_USER_DATA', payload }
};
export function setLanguage(payload) {
    return { type: 'CHANGE_LANGUAGE', payload }
}

export function saveCompanyData(payload) {
    return { type: 'SAVE_COMPANY_DATA', payload }
}

export function setCompanyLayout(payload) {
    return { type: 'SET_COMPANY_LAYOUT', payload }
}

export function saveUsers(payload) {
    return { type: 'SAVE_USERS', payload }
}

export function toggleAlert(payload) {
    return { type: 'TOGGLE_ALERT', payload }
}